export default __webpack_public_path__ + "static/media/tpaita2.b40466c1.webp";